var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:`wzSubBtn wzSubBtn--${_vm.hasSubscribed ? 'opened' : 'closed'}`,attrs:{"href":"javascript:;"},on:{"click":_vm.goSub}},[(_vm.hasSubscribed)?_c('span',[_vm._v(_vm._s(_vm.textClose || '取消微信订阅'))]):_c('span',[_vm._v(_vm._s(_vm.textOpen || '订阅微信通知'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }